"use strict";
const ENCRYPTED_FIELD_PLACEHOLDER = 'xxxxxxxxxx';
const DYNAMIC_ATTRIBUTES_REGEX = /{([^}]*)}/g;
const ENTITY_TYPES = {
    ACCOUNT: 'account',
    USER: 'user',
};
const TASK_DESCRIPTION_FIELDS_REGEX = /\$(\{[^}]*?\})/g;
const JOB_REFERENCE_TYPE = {
    AUTOMATION: 'automation',
    OBJECTIVE_TEMPLATE: 'objective_template',
};
const JOB_TYPES = {
    TASK: 'task',
    FORM_TASK: 'form_task',
    UPDATE_ATTR: 'update_attr',
    CELEBRATE_ALERT: 'celebrate_alert',
    TEAM_ALERT: 'team_alert',
    WEBHOOK: 'webhook',
    IN_APP_EXPERIENCE_UPDATE_DATA: 'in_app_experience_update_data',
    OBJECTIVE: 'objective',
};
module.exports = {
    ENCRYPTED_FIELD_PLACEHOLDER,
    DYNAMIC_ATTRIBUTES_REGEX,
    ENTITY_TYPES,
    TASK_DESCRIPTION_FIELDS_REGEX,
    JOB_REFERENCE_TYPE,
    JOB_TYPES,
};
//# sourceMappingURL=consts.js.map